import { getEnvironment } from '../endpoint';
import { Environment } from './environments';

export function getSitekey(): string {
    switch (getEnvironment()) {
        case Environment.LOCAL:
        case Environment.STAGE:
        case Environment.REF:
        case Environment.DEV:
            return '6Lc9uL4rAAAAAM7FAe9CAKB9uJDJdrAZUeQE7TNT';
        case Environment.PRODUCTION:
            return '6Ld5qKcgAAAAAMoywArOgIrC0lQ7NpYUTsF92PIC';
    }
}
